import React from "react";
import Skeleton from "../../../../components/Skeleton";
import { getWindowWidth, isMobileScreen } from "../../../../services/utils";
import styles from "./subLevel1Desktop.scss"

const LoadingFilterSectionItem = () => (
  <Skeleton style={{ width: "100%", height: 54, margin: 0 }} />
)

export const LoadingFilterSection = ({ style = {} }) => {
  const isMobile = isMobileScreen(getWindowWidth());

  return isMobile ? (
    <div style={{ display: "flex", margin: 20, gap: 15, flexDirection: "column" }}>
      <LoadingFilterSectionItem />
      <LoadingFilterSectionItem />
      <div style={{ display: "flex", gap: 15 }}>
        <LoadingFilterSectionItem />
        <LoadingFilterSectionItem />
      </div>
      <div style={{ display: "flex", gap: 15 }}>
        <LoadingFilterSectionItem />
        <LoadingFilterSectionItem />
      </div>
      <LoadingFilterSectionItem />
      <LoadingFilterSectionItem />
      <LoadingFilterSectionItem />
      <div style={{ marginBottom: 15 }}>
        <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
      </div>
      <div style={{ display: "flex", gap: 15, flexDirection: "row" }}>
        <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
        <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
        <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
        <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
      </div>

    </div>
  ) : (
    <React.Fragment>
      <div
        className={styles.skeletonContainer}
        style={style}
      >

        <div style={{ display: "flex", marginBottom: 15, gap: 15, flexDirection: "row" }}>
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
        </div>
        <div style={{ display: "flex", gap: 15, marginBottom: 15, flexDirection: "row" }}>
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
          <LoadingFilterSectionItem />
        </div>
        <div style={{ marginBottom: 15 }}>
          <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
        </div>
        <div style={{ display: "flex", gap: 15, flexDirection: "row" }}>
          <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
          <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
          <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
          <Skeleton style={{ width: 150, height: 35, margin: 0 }} />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 15 }}>
        <Skeleton style={{ width: 250, height: 35, margin: 0 }} />

      </div>
    </React.Fragment>

  )
}


// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/LoadingFilterSection.tsx